import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const DropdownArrowIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M-3.72475e-05 2.20661C-3.7234e-05 1.89978 0.113174 1.59274 0.340901 1.35285C0.812436 0.856977 1.59688 0.837203 2.09297 1.30852L5.00865 4.08079L7.90413 1.31134C8.39848 0.83829 9.18293 0.855673 9.6562 1.35024C10.1295 1.84503 10.1119 2.62925 9.6173 3.10231L5.86828 6.68879C5.39023 7.14598 4.63729 7.14685 4.15772 6.69161L0.38523 3.10535C0.129472 2.86132 -3.72618e-05 2.53473 -3.72475e-05 2.20661Z"
    />
  </svg>
);

DropdownArrowIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

DropdownArrowIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(10, 8),
};

export default DropdownArrowIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/arrow-down.js